import axios from "axios"
import { apiConstants } from "../../../utils/apiConstants"
import { apiTypes } from "../../../utils/apiTypes"
import apiRequestType from "../../apiRequestType"

const pollDownloadResult = (url) => {
    
    let excelUrl = apiConstants.BASE_URL_1 + apiConstants.SOCIAL.DOWNLOAD_POLL_RESULT(url);
    // Determine the appropriate authentication header
    const securityProviderName = localStorage.getItem("SecurityProviderName");
    let headers = {
        TenantSlugName: localStorage.getItem("tenantName"),
    };

    if (securityProviderName === "aad") {
    headers.Authorization = localStorage.getItem("token");
    } else {
    headers.AuthenticationToken = localStorage.getItem("token");
    }
    return axios.get(excelUrl, {
        responseType: 'blob', // Ensure the response is treated as binary data
        headers: headers
      });    
}

export default pollDownloadResult